import { api } from "../axios";

export interface SelfDeclarationPayload {
  arnCode: string;
  otp: string;
}

export interface SelfDeclarationResponse {
  declaration_link: string;
}

export const submitSelfDeclarationApi = async (
  payload: SelfDeclarationPayload
): Promise<SelfDeclarationResponse> => {
  return api.post("self-declaration/", {
    otp: payload.otp,
    arn_code: payload.arnCode,
  });
};
